// Dependencies
import React, { Component } from "react";
import { Provider } from "react-redux";
import { Route, Switch } from "react-router-dom";

// Store
import { presetsStore } from "../store/store";

// Components
import PresetsList from "./PresetsList/PresetsList.component";
import Footer from "../../home/components/Footer/footer.component";
import PresetConfiguration from "./PresetConfiguration/PresetConfiguration.component";

// Styles
import "./PresetsPage.component.scss";

import { checkPermission } from "../../../utils/Authorization/authorization";

class PresetsPage extends Component {
    render() {
        return (
            <Provider store={presetsStore}>
                <div id="PresetsPage">
                    <Switch>
                        {checkPermission("add_prog_presets") &&
                            "config:settings:progressives:presets:create" && (
                                <Route
                                    path={"/admin/progressives-presets/new"}
                                    component={PresetConfiguration}
                                />
                            )}
                        {checkPermission("add_prog_presets") &&
                            "config:settings:progressives:presets:create" && (
                            <Route
                                path="/admin/progressives-presets/notes/:presetId"
                                component={PresetConfiguration}
                            />
                        )}
                        {checkPermission("add_prog_presets") &&
                            "config:settings:progressives:presets:create" && (
                            <Route
                                path="/admin/progressives-presets/edit/:presetId"
                                component={PresetConfiguration}
                            />
                        )}
                        {checkPermission("list_prog_presets") && (
                            <Route
                                path="/admin/progressives-presets/detail/:presetId"
                                component={PresetConfiguration}
                            />
                        )}

                        {checkPermission("list_prog_presets") && (
                            <Route
                                path={"/admin/progressives-presets"}
                                component={PresetsList}
                            />
                        )}
                    </Switch>
                    <Footer />
                </div>
            </Provider>
        );
    }
}

export default PresetsPage;
